export default __webpack_public_path__ + "static/media/celular-kevlar.c97a5780.png";